import {
  createAsyncThunk,
  createEntityAdapter,
  createReducer,
  EntityState,
} from "@reduxjs/toolkit";

import { getGoodsMain } from "api/goods";
import LoadingStatus from "libs/loading-status";
import { RootState } from "store";
import Goods from "./Goods";

export const fetchGoods = createAsyncThunk(
  "productPayment/fetchGoods",
  async (payload: { shopid: string; }) => {
    // 상품정보에 카테고리 정보가 없어서 삽입 후 반환
    return await getGoodsMain(payload);
  }
);

const goodsEntities = createEntityAdapter<Goods>({
  selectId: (goods) => goods.productTID,
});

export interface ProductPaymentGoods extends EntityState<Goods> {
  loadingStatus: LoadingStatus;
  shopTID: string;
}

const initialState: ProductPaymentGoods = goodsEntities.getInitialState({
  loadingStatus: LoadingStatus.IDLE,
  shopTID: '',
});

export const goodsReducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchGoods.pending, (state) => {
    state.loadingStatus = LoadingStatus.PENDING;
  });
  builder.addCase(fetchGoods.fulfilled, (state, action) => {
    state.loadingStatus = LoadingStatus.SUCCEEDED;
    goodsEntities.addMany(state, action.payload.goodsList);
    state.shopTID = action.payload.shopTID;
  });
  builder.addCase(fetchGoods.rejected, (state) => {
    state.loadingStatus = LoadingStatus.FAILED;
  });
});

export const getGoodsState = (state: RootState) => state.productPayment.goods;
export const getEntities = (state: RootState) => getGoodsState(state).entities;
export const getLoadingStatus = (state: RootState) =>
  getGoodsState(state).loadingStatus;
export const getGoodsList = (state: RootState): Goods[] =>
  Object.values(getEntities(state)) as Goods[];
export const getGoodsListByCategoryId = (
  state: RootState,
  props: { cateTID: string }
) => getGoodsList(state).filter((item) => item.cateTID === props.cateTID);
export const getGoodsById = (state: RootState, props: { id: string }) =>
  getEntities(state)[props.id];

export const getShopTID = (state: RootState) => getGoodsState(state).shopTID;
